export const formatRelanceDate = (value, withTime = false) => {
  if (!value) return "Non renseignée";
  const date = new Date(/^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T12:00:00` : value);
  if (Number.isNaN(date.getTime())) return "Date invalide";
  return date.toLocaleString("fr-FR", {
    ...(/[+-]\d{2}:\d{2}$|Z$/.test(value) ? { timeZone: "Europe/Paris" } : {}),
    day: "2-digit", month: "2-digit", year: "numeric",
    ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}),
  });
};
